import { useTranslation } from 'react-i18next';

import { useGetMyEnrollment } from '../../api/generated/enrollment/enrollment';
import { isProblemError } from '../../api/client';
import { Alert } from '../../design/primitives/Alert';
import styles from './enrollment.module.css';

/**
 * A propria matricula, do ponto de vista do aluno.
 *
 * O professor chega como `displayName` ja mascarado pelo servidor — a tela nao
 * tem, e nunca teve, as partes do nome para exibir por engano.
 */
export function MyEnrollmentPage() {
  const { t } = useTranslation();
  const query = useGetMyEnrollment();

  // 404 aqui nao e falha: e aluno ainda sem matricula, e a tela diz isso.
  if (isProblemError(query.error) && query.error.status === 404) {
    return (
      <div className={styles.page}>
        <h1>{t('enrollment.mine.title')}</h1>
        <Alert tone="info">{t('enrollment.mine.none')}</Alert>
      </div>
    );
  }
  if (query.isError) return <Alert tone="error">{t('error.loadFailed')}</Alert>;

  const enrollment = query.data;
  if (!enrollment) return null;

  return (
    <div className={styles.page}>
      <h1>{t('enrollment.mine.title')}</h1>

      <dl className={styles.definitions}>
        <dt>{t('enrollment.teacher')}</dt>
        <dd>{enrollment.teacher.displayName}</dd>
        <dt>{t('enrollment.startsOn')}</dt>
        <dd>{enrollment.startsOn}</dd>
        <dt>{t('enrollment.endsOn')}</dt>
        <dd>{enrollment.endsOn ?? '—'}</dd>
        <dt>{t('enrollment.status')}</dt>
        <dd>{enrollment.active ? t('enrollment.active') : t('enrollment.ended')}</dd>
      </dl>

      {enrollment.active ? null : <Alert tone="info">{t('enrollment.mine.ended')}</Alert>}
    </div>
  );
}
